export const REDUCTION_ROUTE_SEGMENTS = {
  root: "reduction",
  planId: ":planId",
  baseline: "baseline",
  measures: "measures",
  scenarios: "scenarios",
  roadmap: "roadmap",
} as const;

export const REDUCTION_PATH = `/${REDUCTION_ROUTE_SEGMENTS.root}`;

export const buildReductionPlanPath = (planId: string): string => `${REDUCTION_PATH}/${planId}`;

export const buildReductionBaselinePath = (planId: string): string =>
  `${buildReductionPlanPath(planId)}/${REDUCTION_ROUTE_SEGMENTS.baseline}`;

export const buildReductionMeasuresPath = (planId: string): string =>
  `${buildReductionPlanPath(planId)}/${REDUCTION_ROUTE_SEGMENTS.measures}`;

export const buildReductionScenariosPath = (planId: string): string =>
  `${buildReductionPlanPath(planId)}/${REDUCTION_ROUTE_SEGMENTS.scenarios}`;

export const buildReductionRoadmapPath = (planId: string): string =>
  `${buildReductionPlanPath(planId)}/${REDUCTION_ROUTE_SEGMENTS.roadmap}`;
